import styled from "styled-components";
import { Link } from "react-router-dom";

export const EntireCategoryBackground = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px 5%;
  font-family: "Pretendard", sans-serif;
  gap: 5px;
  background-color: #F1FFF3;
  border-radius: 20px;
  margin: 15px 5% 5px;
`;

export const CategoryLink = styled(Link)`
  flex: 1;
  color: black;
  text-decoration: none;
  display: flex;
  justify-content: center;
`;

export const SemiCategory1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .icon {
    font-size: 2em;
    margin-bottom: 5px;

    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
  }

  p {
    color: #5C5D61;
    font-size: 12px;
    text-align: center;
    margin: 0;
    white-space: nowrap;
  }
`;

export const SemiCategory2 = styled(SemiCategory1)`
`;
